import React from 'react';

import BasePage from '../Routes/MainComponents/base/BasePage.component.jsx';

// Outside Pages
import AboutUs from '../Routes/AboutUs/AboutUsPage.component.jsx';
import ProgramDevelopment from '../Routes/ProgramDevelopment/ProgramPage.component.jsx';
import Insurance from '../Routes/Insurances/InsurancePage.component.jsx';
import Resources from '../Routes/Resources/ResourcePage.component.jsx';
import WCBCertified from '../Routes/WcbCertified/WcbPage.component.jsx';
import OnlineTraining from '../OnlineTraining/TrainingOnlinePage.component.jsx';
import ClassroomTraining from '../Routes/Classroom/TrainingClassroomPage.component.jsx';
import PrivacyPolicy from '../Routes/PrivacyPolicy/PrivacyPolicyPage.component.jsx';
import TermsAndConditions from '../Routes/Terms&Conditions/TermsAndConditionsPage.component.jsx';
import ContactUs from '../Routes/ContactUs/ContactUs.component.jsx';

// Payments
import BuyCourse from '../OnlineTraining/Purchase/BuyPage.component.jsx';
import Purchase from '../OnlineTraining/Purchase/Purchase.component.jsx';

// Newsletter
import UnsubscribeFromNewsletter from '../Newsletter/UnsubscribeNewsletter.component.jsx';

// Authentication
import SignUpComponent from '../Authentication/SignupPage.component.jsx';
import LoginComponent from '../Authentication/LoginPage.component.jsx';
import ForgotPassword from '../Authentication/PasswordReset/ForgotPassword.jsx';
import ResetPassword from '../Authentication/PasswordReset/ResetPassword.jsx';
import CompanySignupPage from '../Authentication/CompSignUp/SignUpCompany.component.jsx';

// Payments
import PurchaseCompleted from '../OnlineTraining/Purchase/CompleteTransaction.component.jsx';

// Trial Page
import TryMe from '../Components/TryMe.component.jsx';

// Unauthorized Page
import Unauthorized from '../Unauthorized/UnauthorizedComponent.component.jsx';

export const publicRoutes = [
  { path: '', element: <AboutUs /> },
  { path: 'program', element: <ProgramDevelopment /> },
  { path: 'purchase', element: <Purchase /> },
  { path: 'terms-and-conditions', element: <TermsAndConditions /> },
  {
    path: 'unsubscribe-from-newsletter',
    element: <UnsubscribeFromNewsletter />,
  },
  { path: 'checkout', element: <BuyCourse /> },
  { path: 'transaction-completed', element: <PurchaseCompleted /> },
  { path: 'contact-us', element: <ContactUs /> },
  { path: 'privacy-policy', element: <PrivacyPolicy /> },
  { path: 'resources', element: <Resources /> },
  { path: 'insurance', element: <Insurance /> },
  { path: 'wcb-certified', element: <WCBCertified /> },
  { path: 'online', element: <OnlineTraining /> },
  { path: 'classroom', element: <ClassroomTraining /> },
  { path: 'company-signup', element: <CompanySignupPage /> },
  { path: 'loading', element: <TryMe /> },
  { path: 'signup', element: <SignUpComponent /> },
  {
    path: 'login',
    element: <BasePage />,
    children: [
      { index: true, element: <LoginComponent /> },
      { path: 'forgot-password', element: <ForgotPassword /> },
      { path: 'reset-password/:token', element: <ResetPassword /> },
    ],
  },
  { path: 'unauthorized', element: <Unauthorized /> },
];
